import { __decorate } from "tslib";
import { _Memo } from '@naturalcycles/js-lib';
import { cookieService } from '../../../cookie.service.js';
import { PixelClickIdCookie } from '../../socialMediaMarketing.model.js';
import { snapchatPixel } from './snapchat.pixel.js';
class SnapchatClient {
    pixelId = '2d475c4b-cd7d-4c79-b787-683c3571b875';
    load() {
        snapchatPixel(this.pixelId);
    }
    getDefaultPayload() {
        return {
            uuid_c1: cookieService.getCookie(PixelClickIdCookie._scid),
            click_id: cookieService.getCookie(PixelClickIdCookie.ScCid),
            page_url: location.href,
        };
    }
    pageView({ id }) {
        window.snaptr?.('track', 'PAGE_VIEW', {
            ...this.getDefaultPayload(),
            transaction_id: id,
        });
    }
    lead({ id, hashedEmail }) {
        window.snaptr?.('track', 'SIGN_UP', {
            ...this.getDefaultPayload(),
            transaction_id: id,
            user_hashed_email: hashedEmail,
        });
    }
    addToCart({ id, amount, currency, plan }) {
        window.snaptr?.('track', 'ADD_CART', {
            ...this.getDefaultPayload(),
            price: amount,
            currency,
            item_category: plan,
            transaction_id: id,
        });
    }
    purchase({ id, amount, currency, plan, hashedEmail, hashedPhone }) {
        window.snaptr?.('track', 'PURCHASE', {
            ...this.getDefaultPayload(),
            price: amount,
            currency,
            item_category: plan,
            transaction_id: id,
            user_hashed_email: hashedEmail,
            user_hashed_phone_number: hashedPhone,
        });
    }
}
__decorate([
    _Memo()
], SnapchatClient.prototype, "load", null);
export const snapchatClient = new SnapchatClient();
